import { useHeaderContext } from "@WahooFitness/wahoo-offline-mfe";
import { useEffect, useRef } from "react";

const useConditionalNavigateUp = (
  appToken: string,
  callback: (...params: any[]) => boolean,
  params: any[]
) => {
  const { navigate } = useHeaderContext();
  const navigationPerformedRef = useRef(false);

  useEffect(() => {
    if (!navigationPerformedRef.current && callback(...params)) {
      navigationPerformedRef.current = true;
      navigate(`/device-config/${appToken}`, {
        replace: true,
        animation: "pop",
      });
    }
  }, [appToken, callback, navigate, params]);
};

export default useConditionalNavigateUp;
